document.addEventListener('DOMContentLoaded', function() {
    // Función para obtener el valor de un parámetro de la URL
  function getURLParameter(name) {
    return new URLSearchParams(window.location.search).get(name);
  }

  // Verifica si el utm_source es 'meta'
  if (getURLParameter('utm_source') === 'meta') {
    // Oculta el elemento con la clase .kl-private-reset-css-Xuajs1
    const element = document.querySelectorAll('.kl-private-reset-css-Xuajs1');
    if (element) {
      console.log(`El parametro en la URL contiene meta, entonces el POPUP de klaviyo se oculta .kl-private-reset-css-Xuajs1`);
      // Crea una etiqueta <style> y añade la regla CSS para ocultar el elemento
    const styleCrear = document.createElement('style');
    styleCrear.innerHTML = `.kl-private-reset-css-Xuajs1 {display: none !important;}`;
    document.head.appendChild(styleCrear);
    }
    if(styleCrear){
      console.log(`se creo el estilo ${styleCrear}`);
    }
  }
  getURLParameter('utm_source');
  
    // Crea el observador
    const observer = new MutationObserver(function(mutationsList, observer) {
        let headers = document.querySelectorAll(".kl-private-reset-css-Xuajs1 h1");
        let popUp = document.querySelectorAll('.kl-private-reset-css-Xuajs1');
      
        // Si hay elementos h1, ejecuta el código y detiene el observador
        if (headers.length > 0) {
            observer.disconnect();  // Deja de observar después de encontrar los elementos

            headers.forEach(function(ache1) {
                console.log(`LO QUE INCLUYE H1 en POPUP es ${ache1}`);
                console.log(`Sus clases son ${ache1.getAttribute("class")}`);
                console.log(`Su etiqueta es ${ache1.tagName}`);

                // Crear un nuevo elemento h3
                let newTag = document.createElement('h3');

                // Copiar los atributos del h1 original al nuevo h3
                for (let attr of ache1.attributes) {
                    newTag.setAttribute(attr.name, attr.value);
                }

                // Copiar el contenido del h1 al nuevo h3
                newTag.innerHTML = ache1.innerHTML;

                // Reemplazar el h1 original con el nuevo h3
                ache1.parentNode.replaceChild(newTag, ache1);

                console.log('El h1 ha sido cambiado a h3');
            });
        }
    });

    // Configuración del observador: Observa cambios en el body
    observer.observe(document.body, {
        childList: true,  // Detecta cambios en los hijos del body
        subtree: true     // También observa los descendientes de los hijos
    });
});
